import React from 'react';
import logo from '../assets/vocalfactorylogo.png';

const Footer = () => {

  const phone = '+233202208006';
  const whatsapp = '+233202208006';
  const email = 'singwithvocalfactory@gmail.com';
  const sms = '+233202208006';

  return (
    <footer className="footer card">
      <div style={{display:'flex',gap:'1rem',alignItems:'center',justifyContent:'center',marginBottom:'1rem'}}>
        <img src={logo} alt="logo" style={{width:48,height:48}} />
        <div style={{textAlign:'left'}}>
          <strong>Vocal Factory Global</strong>
          <div style={{color:'var(--muted)'}}>Delivering professional vocal work since 2018</div>
        </div>
      </div>

      <div style={{marginBottom:'1rem'}}>
        <a className="btn" href={`https://wa.me/${whatsapp.replace(/[^\d]/g,'')}?text=Hi%20I%20found%20you%20on%20the%20website`} target="_blank" rel="noreferrer">WhatsApp</a>
        <a className="btn secondary" style={{marginLeft:10}} href={`mailto:${email}`}>Email</a>
        <a className="btn secondary" style={{marginLeft:10}} href={`tel:${phone}`}>Call</a>
        <a className="btn secondary" style={{marginLeft:10}} href={`sms:${sms}`}>SMS</a>
      </div>

      <div style={{color:'var(--muted)'}}>Follow us:
        <a style={{marginLeft:8}} href="https://www.instagram.com/vocalfactoryglobal" target="_blank" rel="noreferrer">Instagram</a>  ·
        <a style={{marginLeft:8}} href="https://web.facebook.com/profile.php?id=61556910941094" target="_blank" rel="noreferrer">Facebook</a> 
        {/* <a style={{marginLeft:8}} href="https://twitter.com" target="_blank" rel="noreferrer">X</a> */}
      </div>

      <div style={{marginTop:12,color:'var(--muted)'}}>© {new Date().getFullYear()} Vocal Factory Global</div>
      <small><div style={{marginTop:12,color:'var(--muted)'}}><i>Powered by AS Tech. World | iFire Creations</i></div></small>
    </footer>
  );
};

export default Footer;
